<template>
  <div class="screenloading">
    <div class="main-content" v-if="!isUserGroupAdmin">
      <div class="container-fluid padding-left-3Perc margin-bottom-2Perc">
        <screen-loading-searchbar @searchResults="getSearchResults" @refreshList="getScreenLoadingList">></screen-loading-searchbar>
        <div class="">
          <screen-loading-list v-if="showScreenLoadingList" v-bind:screenLoadingList="screenLoadingList" @updatedScreenLoadingList="updateToLatestScreenLoadingList" @refreshList="getScreenLoadingList">></screen-loading-list>
        </div>
      </div>
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
      </div>
      <loader></loader>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
      <div class="row margin-Top-3Perc">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <Copyright-Element class="footer"></Copyright-Element>
        </div>
      </div>
    </div>
    <error-page v-if="isUserGroupAdmin"></error-page>  
  </div>
</template>

<script>
import AlertBox from '@/components/AlertOverlay'
import Loader from '@/components/dashboard/Loader'
import ScreenLoadingSearchbar from '@/components/screen_loading/ScreenLoadingSearchBar'
import ScreenLoadingList from '@/components/screen_loading/ScreenLoadingList'
import { screenLoadingService } from '@/server-util/screen-loading-services'
import { constants } from '@/utils/constants'
import CopyrightElement from '@/components/CopyrightElement'
import ErrorPage from '@/pages/Error'
import { participantService } from '@/server-util/participant-service'
export default {
  created: function () {
    this.checkUserErrorStatus()
    this.getScreenLoadingList()
  },
  data: function () {
    return {
      showScreenLoadingList: false,
      showAlertDialog: false,
      errorMsg: '',
      serchResult: [],
      showSpinner: false,
      screenLoadingList: []
    }
  },
  components: {
    'screen-loading-searchbar': ScreenLoadingSearchbar,
    'screen-loading-list': ScreenLoadingList,
    'Copyright-Element': CopyrightElement,
    'error-page': ErrorPage,
    'loader': Loader,
    'alert-box': AlertBox
  },
  methods: {
    checkUserErrorStatus: function () {
      var storeObj = this.$store
      if (storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== '') {
        participantService
          .getUserErrorStatus(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              const jsonObj = responseObj.data
              this.checkAndShowAlert(jsonObj)
            }
          }, errorObj => {
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            console.log('getUserErrorStatus Error :::' + this.errorMsg)
          })
      } else {
        console.log(
          'Access Token or required data is NULL hence declined LOADING GET ERROR INFO'
        )
      }
    },
    checkAndShowAlert: function (jsonObj) {
      if (jsonObj !== undefined && jsonObj !== 'undefined' && jsonObj !== null && jsonObj !== 'null' && jsonObj !== '') {
        const isLoggedOut = jsonObj.IsAdminLoggedOut
        const profileError = jsonObj.ProfileError
        if (isLoggedOut) {
          this.showAlertDialog = true
          this.errorMsg = constants.Logged_Out_From_Another_Platform_Error_Msg
        } else if (profileError === constants.Change_Password_Error_Profile) {
          this.showAlertDialog = true
          this.errorMsg = constants.Change_Password_Alert_Msg
        }
      }
    },
    peformCleanUpOperationOnSignOut: function () {
      var store = this.$store
      var cookies = this.$cookies
      cookies.remove(constants.LOGIN_COOKIE_KEY)
      cookies.remove(constants.LOGIN_USER_COOKIE)
      store.state.isUserProfileLoaded = false
      localStorage.removeItem(constants.LOGIN_USER_COOKIE)
      localStorage.setItem('selectedMenu', 0)
      localStorage.setItem('selectedSubMenu', 0)
      localStorage.clear()
      this.$store.state.curr_user = null
      this.$store.commit('resetState')
      this.$router.push('/')
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
      switch (this.errorMsg) {
        case constants.Logged_Out_From_Another_Platform_Error_Msg:
          this.peformCleanUpOperationOnSignOut()
          break
        case constants.Change_Password_Alert_Msg:
          localStorage.setItem('selectedMenu', constants.MenuOptionsEnum.Settings)
          localStorage.setItem('selectedSubMenu', constants.SubMenuOptionsEnum.EditProfile)
          this.$router.push('/profile?OpenPopUp=true')
          break
      }
    },
    getSearchResults (value) {
      // AK: In order to get search Results entered in Search box
      this.screenLoadingList = value
    },
    updateToLatestScreenLoadingList (value) {
      // AK: Used to update the Master list (When user updates it)
      this.$store.state.screenLoadingList = value
      this.screenLoadingList = value
      this.getScreenLoadingList()
    },
    filteredLearningLevelList (value) {
      // AK: Use to show flitered list if they entered any word in Search
      this.screenLoadingList = value
    },
    getScreenLoadingList: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined || storeObj.state.access_token !== null || storeObj.state.access_token !== ''
      ) {
        // AK: Check weather master learning level list is already present or not?
        // console.log('storeObj.state' + JSON.stringify(storeObj.state))
        console.log('Loading List issue' + JSON.stringify(storeObj.state.screenLoadingList))
        if (storeObj.state.screenLoadingList === 0) {
          // _this.showSpinner = true
          _this.$store.state.isLoading = true
        } else {
          _this.screenLoadingList = storeObj.state.screenLoadingList
          // AK: If List is present then show results to user
          _this.updateShowScreenLoadingListFlag(true)
        }
        screenLoadingService
          .listAllScreensLoading(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // SS: Store it
              console.log('List AllScreens Loading responseObj. data ' + JSON.stringify(responseObj.data))
              storeObj.state.screenLoadingList = responseObj.data
              if (_this.$store.state.isLoading === true) {
                // SS: Hide Spinner after recieving Cohort list
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
                // SS: After getting Screen Loading list from server
                _this.updateShowScreenLoadingListFlag(true)
              }
              // AK: Show cohort List data initially when loaded (Without Filter)
              _this.screenLoadingList = responseObj.data
            } else {
              if (_this.$store.state.isLoading === true) {
                // SS: Hide Spinner
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            if (_this.$store.state.isLoading === true) {
              // SS: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            }
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined LOADING LEARNING LEVEL LIST'
        )
      }
    },
    updateShowScreenLoadingListFlag: function (value) {
      // AK: Used to show list when server call completed
      this.showScreenLoadingList = value
    }
  },
  computed: {
    getAllFilesValues: {
      get: function () {
        return this.serchResult
      }
    },
    isUserGroupAdmin: {
      get: function () {
        var userObj = this.$store.state.curr_user
        if (parseInt(userObj.AccountType) === parseInt(constants.UserAccountType.Group_Admin)) {
          return true
        } else {
          return false
        }
      }
    }
  },
  name: 'screenloading'
}
</script>

<style scoped>
.animationload {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10000;
}
.osahanloading {
    animation: 1.5s linear 0s normal none infinite running osahanloading;
    background: #fed37f none repeat scroll 0 0;
    border-radius: 50px;
    height: 50px;
    left: 50%;
    margin-left: -25px;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 50px;
}
.osahanloading::after {
    animation: 1.5s linear 0s normal none infinite running osahanloading_after;
    border-color: #85d6de transparent;
    border-radius: 80px;
    border-style: solid;
    border-width: 10px;
    content: "";
    height: 80px;
    left: -15px;
    position: absolute;
    top: -15px;
    width: 80px;
}
@keyframes osahanloading {
0% {
    transform: rotate(0deg);
}
50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
}
100% {
    transform: rotate(360deg);
}
}
.screenloading {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.left-color-border
{
	border: 1px solid red;
}
.right-color-border
{
	border: 1px solid green;
}
.leftNavBarBG
{
	background-color: #34495e;
  /*border:1px solid #34495e; */
}
.font-size-14px{
	font-size: 30px;
}
.position-Fixed
{
	position:fixed;
}
.float-Right
{
	float: right;
}
.fullHeight
{
	height:100% !important;
}
.fi-border
{
	border: 1px solid white;
}
 .footer-img
 {
    margin: 0 auto !important;
    display: block;
    position: absolute;
    bottom: 0;
	width: 30%;
 }
 .center-block {
   margin-left:auto;
   margin-right:auto;
   display:block;
}
.text-center {
   text-align:center
}
.margin-Top-14Perc
{
	margin-top: 14%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}
.margin-Top-3Perc{
  margin-top: 3% !important;
}
.margin-Top-5Perc
{
	margin-top: 5%;
}
.admin-Panel-BG
{
  background-color: #f39c12;
}
.text-align-left
{
  text-align: left;
}
.margin-Left-4Perc
{
  margin-left: 4%;
}
.admin-Panel-Padding
{
  padding:0.1% 0% 0.1% 2%;
}
.font-size-2vw
{
  font-size: 2vw;
}
.width-17Perc{
  width:17%;
}
.padding-left-3Perc{
  padding-left: 3%;
}
/* Using Only for footer */
.footer{
  /* position: fixed; */
    left: 0;
    bottom: 0;
    width: 100%;
    /* background-color: red; */
    /* color: white; */
    text-align: center;
    margin-bottom: 1%;
    font-size: 12px;
}
.height-150px{
  height: 150px;
}
</style>


// WEBPACK FOOTER //
// src/pages/ScreenLoading.vue